import axios from 'axios'

// 生成滑动验证码
export const generateCaptcha = (captchaType = 'blockPuzzle') =>
  axios.post('/api/auth/captcha/generate', { captchaType })

// 校验滑动验证码
export const verifyCaptcha = (data) =>
  axios.post('/api/auth/captcha/verify', data)

// 发送短信验证码
export const sendSmsCode = (phone, captchaVerification) =>
  axios.post('/api/auth/sms/send', { phone, captchaVerification })

// 发送邮件验证码
export const sendEmailCode = (email, captchaVerification) =>
  axios.post('/api/auth/email/send', { email, captchaVerification })

// 验证码登录
export const loginByCode = (data) =>
  axios.post('/api/auth/login', data)

// 账号密码登录
export const loginByPassword = (data) =>
  axios.post('/api/auth/login/password', data)

// 新用户设置用户名和密码
export const setPassword = (data) =>
  axios.post('/api/auth/set-password', data)

// 刷新 Token
export const refreshToken = () =>
  axios.post('/api/auth/refresh')

// 退出登录
export const logout = (token = localStorage.getItem('token')) =>
  axios.post('/api/auth/logout', null, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    skipAuthHeader: true,
    skipAuthRefresh: true,
    timeout: 10000,
  })

// 获取用户协议
export const getUserAgreement = () =>
  axios.get('/api/agreement/user')

// 获取隐私政策
export const getPrivacyPolicy = () =>
  axios.get('/api/agreement/privacy')

// 获取用户资料
export const getUserProfile = () =>
  axios.get('/api/user/profile')

// 更新用户资料
export const updateProfile = (data) =>
  axios.put('/api/user/profile', data)

// 修改密码
export const changePassword = (data) =>
  axios.post('/api/user/change-password', data)

// 获取用户统计
export const getUserStats = () =>
  axios.get('/api/user/stats')

// 绑定/换绑邮箱（需要先获取验证码）
export const bindEmail = (data) =>
  axios.post('/api/user/bind-email', data)

// 绑定/换绑手机号（需要先获取验证码）
export const bindPhone = (data) =>
  axios.post('/api/user/bind-phone', data)

// 已登录用户发送验证码（免滑动验证码）
export const sendBindCode = (account, accountType) =>
  axios.post('/api/user/send-code', { account, accountType })

// 选择身份（两步登录第二步）
export const selectIdentity = (identityId) =>
  axios.post('/api/auth/select-identity', { identityId })

// 创建个人身份（企业用户自助创建）
export const createPersonalIdentity = (data) =>
  axios.post('/api/user/personal-identity', data)
